import { filter } from 'lodash';
import { useFilterData } from '../filterContext';

export const useItemFilterFunction = (): ((itemList: any[]) => any[]) => {
  const {
    commonFilterState: { filterText },
  } = useFilterData();

  const filterItemList = (itemList: any[]): any[] => {
    /** Shorthand for the string-based format lodash wnats */
    // apply filters first
    return filter(itemList, w => inFitler.searchText(w, filterText));
  };
  return filterItemList;
};

export const inFitler = {
  /** Returns true if filterText is found within the item anywhere.
   *
   * @param {object} item the item we're checking
   * @param {string} filterText text to search the item for
   * @returns {boolean} true if the value is in the filterList
   */
  searchText: (item: object, filterText: string | undefined): boolean => {
    if (!filterText || filterText.length < 1) {
      //don't even bother processing if we don't have any text
      return true;
    }
    const itemAsText = JSON.stringify(item);
    return itemAsText.toLowerCase().indexOf(filterText.toLowerCase()) > -1;
  },
};
